import { Injectable } from '@angular/core';
import { ApiService } from '../../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class FooterService {

  constructor(private apiService: ApiService) {
  }

  getFooterMenus() {
    const endpoint = 'customer/footer/menus-data';
    return this.apiService.get(endpoint);
  }
}
